import React from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string, number, func } from 'prop-types'

import Tooltip from 'Pods/Shared/Tooltip'

import useMobileClick from './hooks/useMobileClick'

function TotalEarnings({ id, salesCount, earnings, onClick = null }) {
  const { props: clickProps, isMobile } = useMobileClick(onClick)

  const content = isMobile ? (
    earnings
  ) : (
    <Tooltip
      id={`earnings-tooltip-${id}`}
      className="u-block"
      content={`Earnings from ${salesCount} ${salesCount === 1 ? 'order' : 'orders'}`}
    >
      {earnings}
    </Tooltip>
  )

  if (!onClick) return content

  return (
    <Button
      type="ghost-primary"
      size="small"
      {...clickProps}
      customClass="total-earnings-clickable"
    >
      {content}
    </Button>
  )
}

TotalEarnings.propTypes = {
  id: string.isRequired,
  salesCount: number.isRequired,
  earnings: string.isRequired,
  onClick: func,
}

export default TotalEarnings
